module.exports = __webpack_public_path__ + "static/media/loading.8375fc44.svg";